import React, { useState, useMemo } from 'react';
import Loader from '../../../../components/Loader';
import Wordings from '../../../../config/stringTable';
import { LanguageConsumer } from '../../../../config/LanguageContext';

export default function AkoyaLoader() {
  const [longLoading, setLongLoading] = useState(false);
  useMemo(() => {
    setTimeout(() => setLongLoading(true), 8000);
  }, []);
  return (
    <>
      <Loader />
      <LanguageConsumer>
        {({ language }) => (
          <>
            <h6>
              { Wordings[language]['Authorizing your account'] }
            </h6>
            <p className="loading-text">
              {longLoading
                ? Wordings[language].BanksCanTakeAwhile
                : Wordings[language].SendingCredentials}
            </p>
          </>
        )}
      </LanguageConsumer>
    </>
  );
}
